"use client";

import Link from "next/link";
import type { ReactNode } from "react";
import { captureEvent, POSTHOG_EVENTS } from "@/lib/analytics/posthog";
import { usePostHog } from "@/lib/analytics/posthog-react";

type CreateCtaLinkProps = {
  href?: string;
  source: string;
  className?: string;
  children: ReactNode;
};

export function CreateCtaLink({
  href = "/create",
  source,
  className,
  children,
}: CreateCtaLinkProps) {
  const posthog = usePostHog();

  return (
    <Link
      href={href}
      className={className}
      onClick={() =>
        captureEvent(posthog, POSTHOG_EVENTS.ctaCreateClick, {
          source,
        })
      }
    >
      {children}
    </Link>
  );
}
